/** Quien pidió menos movimiento al sistema no ve animaciones ni desplazamientos. */
export const prefersCalm = () =>
  typeof window !== "undefined" &&
  (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false);

const easeInOutCubic = (k) =>
  k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;

/**
 * Lleva la página hasta la sección `id` sin brincar: un desplazamiento pausado
 * (de 0.7 a 1.6 s según la distancia) que arranca y frena suave. Así lo pidió
 * negocio para «Contratar», que baja hasta el contacto. Si la persona toca la
 * rueda o la pantalla a medio camino, se detiene y la deja en paz.
 */
export const scrollToSection = (id, { instant = false } = {}) => {
  const target = document.getElementById(id);
  if (!target) return;

  const nav = document.querySelector(".lp-navbar");
  const to =
    target.getBoundingClientRect().top +
    window.scrollY -
    (nav?.offsetHeight ?? 0) -
    12;

  // "instant": Bootstrap pone scroll-behavior: smooth en :root, y cada paso
  // de esta animación se suavizaría otra vez encima.
  if (instant || prefersCalm()) {
    window.scrollTo({ top: to, behavior: "instant" });
    return;
  }

  const from = window.scrollY;
  const distance = to - from;
  const duration = Math.min(1600, Math.max(700, Math.abs(distance) * 0.35));
  const start = performance.now();
  let cancelled = false;
  const cancel = () => {
    cancelled = true;
  };
  window.addEventListener("wheel", cancel, { once: true, passive: true });
  window.addEventListener("touchstart", cancel, { once: true, passive: true });

  const step = (now) => {
    if (cancelled) return;
    const k = Math.min(1, (now - start) / duration);
    window.scrollTo({
      top: from + distance * easeInOutCubic(k),
      behavior: "instant",
    });
    if (k < 1) {
      requestAnimationFrame(step);
    } else {
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchstart", cancel);
    }
  };
  requestAnimationFrame(step);
};
